type CacheEntry = { orgId: string; ids: Set<string>; at: number };

let cache: CacheEntry | null = null;

export const COMBO_PARENT_IDS_CACHE_TTL_MS = 60_000;

export function readComboParentProductIdsCache(orgId: string): Set<string> | null {
  if (!cache || cache.orgId !== orgId || Date.now() - cache.at >= COMBO_PARENT_IDS_CACHE_TTL_MS) {
    return null;
  }
  return cache.ids;
}

export function writeComboParentProductIdsCache(orgId: string, ids: Set<string>): void {
  cache = { orgId, ids, at: Date.now() };
}

export function invalidateComboParentProductIdsCache(): void {
  cache = null;
}
